import { toast } from "../components/razor-reuse";
import axios from "axios";

const API = process.env.REACT_APP_BASE_URL;

/** base url to make request to the BE end point */

const instance = axios.create({
  baseURL: API,
});

instance.interceptors.request.use(
  async (config: any) => {
    const token = localStorage.getItem("token");
    // logger.log(token, 'the token');
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token.toString()}`,
        redirect: "follow",
      };
      return config;
    } else {
      // delete config.headers.common["Authorization"];
      return config;
    }
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// const logoutFunc = () => {
//   localStorage?.clear();
//   window?.location?.reload();
// };

instance.interceptors.response.use(
  async (response: any) => {
    // console.log(response);

    return response;
  },
  async (error: any) => {

    if (error?.response?.data?.status === "failed") {
  
      if (
        error?.response?.data?.message === "Requested resource is not found" ||
        error?.response?.data?.message === "This action is unauthorized."
      ) {
        // console.log("yes, --------------------------------");
        return error;
      }
      if (
        error?.response?.data?.message ===
        "Unauthenticated. Please login to proceed"
      ) {
        // console.log("jhssssssssss");
        // toast.error(error?.response?.data?.message);
        // setTimeout(() => {
        //   logoutFunc();
        // }, 1500);
        return error;
      }

      if (error?.response?.data?.error?.message) {
    

        const genMsg = error?.response?.data?.error?.message;
        toast.error(genMsg as any);
      }

      if (Object?.values(error?.response?.data?.errors)[0]) {
        const msg = Object?.values(error?.response?.data?.errors)[0];
        toast.error(msg as any);
      }

      return;
    }
    if (error?.response?.status === 422) {
      // toast.error(`${error?.response?.data?.message}`, {
      //   theme: "colored",
      //   // toastId: customErrorId,
      // });
      //   console.log(error);
      return error;
    }
    if (error?.response?.status !== 401) {
  
      return error;
    }
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.message === "Not authorized!"
    ) {
      toast.error(`${error?.response?.data?.message}`, {
        theme: "colored",
        // toastId: customErrorId,
      });
      return error;
    }
    return error;
  }
);

export default instance;
